// cannot use destructuring here as this is parsed by parcel
/* eslint prefer-destructuring: 0 */

// Docker Desktop on Windows: localhost often resolves to broken IPv6; 127.0.0.1 works.
function devApiBase(endpoint) {
  const base = endpoint || 'http://127.0.0.1:16000';
  return base.replace(/\/\/localhost(?=[:/])/g, '//127.0.0.1');
}

export const WS_ENDPOINT = process.env.WS_ENDPOINT;
export const STATIC_SERVER = process.env.STATIC_SERVER || '';
export const GTMID = process.env.GTMID || '';
export const ESIGN_ENDPOINT = devApiBase(process.env.ESIGN_ENDPOINT);
export const FRONTEND_BASE_URL = process.env.FRONTEND_BASE_URL;
export const LOGLEVEL = process.env.LOGLEVEL;
export const VERSION_NUMBER = process.env.VERSION_NUMBER || '0.1';
export const DEBOUNCE_TABLE_REFETCH_MS = process.env.DEBOUNCE_TABLE_REFETCH_MS;
export const DEBOUNCE_TIMEOUT = process.env.DEBOUNCE_TIMEOUT;
export const REDIRECTION_TIMEOUT = process.env.REDIRECTION_TIMEOUT;
export const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY;
export const SHOW_CAPTCHA = process.env.SHOW_CAPTCHA;
export const ENVIRONMENT = process.env.ENVIRONMENT;
export const ZUM_FORM_URL = process.env.ZUM_FORM_URL;
export const FEE_AMOUNT = 89.00;

const GCS_PUBLIC_HOST = 'https://storage.googleapis.com/';

/**
 * Dev-only: route public GCS PDF URLs through webpack /gcs-proxy (same-origin).
 * Avoids CORS when UI is at http://127.0.0.1:10000 but bucket CORS lists localhost only.
 */
export function pdfViewerUrl(sourceUrl) {
  if (!sourceUrl || process.env.NODE_ENV !== 'development') {
    return sourceUrl;
  }
  if (sourceUrl.indexOf(GCS_PUBLIC_HOST) !== 0) {
    return sourceUrl;
  }
  const path = sourceUrl.slice(GCS_PUBLIC_HOST.length);
  return `/gcs-proxy/${path}`;
}
